import { FaqMediaBlock } from './FaqMediaBlock.jsx';

function formatFileSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * @param {{ items: Array<any>; projectId?: number; clientId?: number; showMeta?: boolean }} props
 */
export function AssetLibraryList({ items, projectId, clientId, showMeta = true }) {
  if (!items?.length) {
    return <p className="muted">No assets found.</p>;
  }

  return (
    <ul className="list-plain">
      {items.map((item) => (
        <li key={item.id} className="auth-card flat" style={{ marginBottom: '0.75rem' }}>
          <div className="row-actions" style={{ alignItems: 'flex-start', gap: '1rem' }}>
            <FaqMediaBlock
              block={{
                id: item.id,
                type: item.type,
                has_file: item.has_file !== false,
                file_url: item.file_url,
                file: {
                  name: item.file_name || item.label,
                  size: item.file_size,
                  is_image: item.type === 'image' || item.file_mime?.startsWith('image/'),
                },
                content: { label: item.label },
              }}
              projectId={projectId}
              clientId={clientId}
              variant="thumb"
            />
            <div style={{ flex: 1 }}>
              <strong>{item.label || item.file_name}</strong>
              {item.approval_status && item.approval_status !== 'approved' ? (
                <span className="badge badge-warn"> {item.approval_status}</span>
              ) : null}
              {showMeta ? (
                <div className="muted small">
                  {item.client_name ? `${item.client_name}` : ''}
                  {item.project_name ? ` · ${item.project_name}` : ''}
                  {item.category_title ? ` · ${item.category_title}` : ''}
                  {item.file_size ? ` · ${formatFileSize(item.file_size)}` : ''}
                </div>
              ) : null}
              {item.item_title ? <div className="muted small">{item.item_title}</div> : null}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
